// import { CartContext } from "../CartContext";
// import { useContext, useState, useEffect } from "react";
// import { getProductData } from "../productsStore";
// import { RiDeleteBin6Line } from "react-icons/ri";
// import { Card, Form, Row, Col, Button } from 'react-bootstrap';
// import "../cartProduct.css"

// function CartProduct(props) {
//     const cart = useContext(CartContext);
//     const id = props.id;
//     const quantity = props.quantity;
//     const [inputQuantity, setInputQuantity] = useState(quantity);

//     useEffect(() => {
//         setInputQuantity(quantity);
//     }, [quantity]);

//     const handleInputChange = (e) => {
//         const val = e.target.value;
//         if (/^\d*$/.test(val)) {
//             setInputQuantity(val);
//         }
//     };

//     const handleInputBlur = () => {
//         const qty = parseInt(inputQuantity, 10);
//         if (!isNaN(qty)) {
//             cart.updateQuantity(id, qty);
//         } else {
//             setInputQuantity(quantity);
//         }
//     };

//     const handleStarClick = (newRating) => {
//         props.onRatingChange(id, newRating);
//     };

//     const productData = getProductData(cart.items, id);
//     const productQuantity = productData.quantity;

//     const totalPrice = productQuantity === 0
//         ? productData.price * 1
//         : (productData.price * productQuantity).toFixed(2);

//     const renderStars = () => {
//         const stars = [];
//         for (let i = 1; i <= 5; i++) {
//             stars.push(
//                 <span
//                     key={i}
//                     style={{
//                         cursor: "pointer",
//                         fontSize: "20px",
//                         color: i <= props.rating ? "orange" : "gray",
//                     }}
//                     onClick={() => handleStarClick(i)}
//                 >
//                     ★
//                 </span>
//             );
//         }
//         return stars;
//     };

//     return (
//         <>
//             <div className="cart-product" style={{ paddingBottom: "60px" }}>
//                 <div style={{
//                     position: "absolute",
//                     top: "10px",
//                     right: "10px",
//                     padding: "5px 10px",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "4px"
//                 }}>
//                     <RiDeleteBin6Line onClick={() => cart.deleteFromCart(id)} />
//                 </div>
//                 <table style={{ width: "100%" }}>
//                     <thead style={{
//                         backgroundColor: "#007bff",
//                         color: "white",
//                         fontWeight: "bold",
//                         textAlign: "center",
//                     }}>
//                         <tr>
//                             <th colSpan="4" style={{ padding: "10px" }}>
//                                 #{props.id} - {productData.style} - {productData.size}
//                             </th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         <tr>
//                             <td rowSpan={2} style={{ padding: 5, alignItems: "center" }}>
//                                 <img src={productData.image} alt={productData.style} style={{ maxWidth: 100, maxHeight: 100 }} />
//                             </td>
//                         </tr>
//                         <tr>
//                             <td style={{ padding: 10 ,paddingLeft:85}}>Unit Price: ${productData.price}</td>
//                         </tr>
//                     </tbody>
//                 </table>

//                 {/* Quantity Controls */}
//                 <div style={{
//                     position: "absolute",
//                     bottom: "10px",
//                     right: "10px",
//                     display: "flex",
//                     gap: "10px",
//                     alignItems: "center"
//                 }}>
//                     <button
//                         onClick={() => cart.addOneToCart(productData.id)}
//                         style={{
//                             padding: "5px 10px",
//                             backgroundColor: "#28a745",
//                             color: "#fff",
//                             border: "none",
//                             borderRadius: "4px"
//                         }}
//                     >
//                         +
//                     </button>

//                     <input
//                         type="number"
//                         value={inputQuantity}
//                         onChange={handleInputChange}
//                         onBlur={handleInputBlur}
//                         min="0"
//                         style={{
//                             width: "50px",
//                             textAlign: "center",
//                             padding: "5px",
//                             borderRadius: "4px",
//                             border: "1px solid #ccc",
//                         }}
//                     />

//                     <button
//                         onClick={() => cart.removeOneFromCart(productData.id)}
//                         style={{
//                             padding: "5px 10px",
//                             backgroundColor: "#dc3545",
//                             color: "#fff",
//                             border: "none",
//                             borderRadius: "4px"
//                         }}
//                     >
//                         -
//                     </button>
//                 </div>

//                 {/* Rating */}
//                 <div style={{ position: "absolute", bottom: "-15px", left: "10px", padding: "5px" }}>
//                     <div style={{ fontSize: "15px" }}>
//                         {renderStars()}
//                     </div>
//                     <div style={{ marginTop: "5px", fontSize: "12px", marginBottom:10}}>
//                         <p style={{ fontSize: "9.7px", marginLeft:-5 }}>How easy did you find this product?</p>
//                     </div>
//                 </div>
//             </div>
//             <hr />
//         </>
//     );
// }

// export default CartProduct;

import { CartContext } from "../CartContext";
import { useContext, useState, useEffect } from "react";
import { getProductData } from "../productsStore";
import { RiDeleteBin6Line } from "react-icons/ri";
import "../cartProduct.css";

function CartProduct(props) {
  const cart = useContext(CartContext);
  const id = props.id;
  const quantity = props.quantity;
  const [inputQuantity, setInputQuantity] = useState(quantity);

  useEffect(() => {
    setInputQuantity(quantity);
  }, [quantity]);

  const handleInputChange = (e) => {
    const val = e.target.value;

    // Allow only numbers
    if (/^\d*$/.test(val)) {
      setInputQuantity(val);

      // Update cart immediately
      const qty = parseInt(val, 10);
      if (!isNaN(qty)) {
        cart.updateQuantity(id, qty);
      } else {
        cart.updateQuantity(id, 0); // optional: treat empty input as 0
      }
    }
  };

  const handleInputBlur = () => {
    const qty = parseInt(inputQuantity, 10);
    if (!isNaN(qty)) {
      cart.updateQuantity(id, qty);
    } else {
      setInputQuantity(quantity);
    }
  };

  const handleStarClick = (newRating) => {
    props.onRatingChange(id, newRating);
  };

  const productData = getProductData(cart.items, id);
  const productQuantity = productData.quantity;

  // === Discount logic ===
  let discount = 0;
  if (productQuantity >= 24 && productQuantity <= 47) {
    discount = 0.1;
  } else if (productQuantity >= 48 && productQuantity <= 99) {
    discount = 0.15;
  } else if (productQuantity >= 100) {
    discount = 0.2;
  }

  const basePrice = parseFloat(productData.price) || 0;
  const discountedUnitPrice = (basePrice * (1 - discount)).toFixed(2);
  const totalPrice = (basePrice * (1 - discount) * productQuantity).toFixed(2);

  // === Promotional message ===
  const getPromoMessage = () => {
    if (discount === 0 && productQuantity < 24) {
      return "Buy 24+ to save 5%!";
    } else if (discount === 0.1) {
      return "You’re saving 5%! Buy 48+ to save 10%.";
    } else if (discount === 0.15) {
      return "You’re saving 10%! Buy 100+ to save 15%.";
    } else if (discount === 0.2) {
      return "You’re saving 15%! Great deal!";
    }
    return "";
  };

  const renderStars = () => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span
          key={i}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: i <= props.rating ? "orange" : "gray",
          }}
          onClick={() => handleStarClick(i)}
        >
          ★
        </span>,
      );
    }
    return stars;
  };

  return (
    <>
      <div
        className="cart-product"
        style={{ paddingBottom: "70px", position: "relative" }}
      >
        {/* Delete Button */}
        <div
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            padding: "5px 10px",
            color: "white",
            border: "none",
            borderRadius: "4px",
          }}
        >
          <RiDeleteBin6Line onClick={() => cart.deleteFromCart(id)} />
        </div>

        {/* Product Table */}
        <table style={{ width: "100%" }}>
          <thead
            style={{
              backgroundColor: "#007bff",
              color: "white",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            <tr>
              <th colSpan="4" style={{ padding: "10px" }}>
                #{props.id} 
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowSpan={2} style={{ padding: 5, alignItems: "center" }}>
                <img
                  src={productData.image}
                  alt={productData.style}
                  style={{ maxWidth: 100, maxHeight: 100 }}
                />
              </td>
            </tr>
            <tr>
              <td style={{ padding: 10, paddingLeft: 85 }}>
                <div>Unit Price: ${discountedUnitPrice}</div>
                {discount > 0 && (
                  <div style={{ color: "green", fontSize: "13px" }}>
                    (Original: ${productData.price})
                  </div>
                )}
                <div
                  style={{
                    marginTop: "5px",
                    fontSize: "12px",
                    color: discount > 0 ? "green" : "#007bff",
                  }}
                >
                  {getPromoMessage()}
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        {/* Quantity Controls */}
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            right: "10px",
            display: "flex",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <button
            onClick={() => cart.addOneToCart(productData.id)}
            style={{
              padding: "5px 10px",
              backgroundColor: "#28a745",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
            }}
          >
            +
          </button>

          <input
            type="number"
            value={inputQuantity}
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            min="0"
            style={{
              width: "50px",
              textAlign: "center",
              padding: "5px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          />

          <button
            onClick={() => cart.removeOneFromCart(productData.id)}
            style={{
              padding: "5px 10px",
              backgroundColor: "#dc3545",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
            }}
          >
            -
          </button>
        </div>

        {/* Rating */}
        {/* <div
          style={{
            position: "absolute",
            bottom: "-15px",
            left: "10px",
            padding: "5px",
          }}
        > */}
        {/* <div style={{ fontSize: "15px" }}>{renderStars()}</div> */}
        {/* <div
            style={{
              marginTop: "5px",
              fontSize: "12px",
              marginBottom: 10,
            }}
          >
            <p style={{ fontSize: "9.7px", marginLeft: -5 }}>
              How easy did you find this product?
            </p>
          </div> */}
        {/* </div> */}
      </div>
      <hr />
    </>
  );
}

export default CartProduct;
